import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";

const EnterOfSettlementsBalancesList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.EnterOfSettlementsBalances} />
        </>
    );
}

export default EnterOfSettlementsBalancesList;